"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import i18n from "@/lang";
import AddInprogressShopsDialog from "@/views/safemanagements/InprogressManager/dialogs/AddInprogressShopsDialog.vue";
export class AddOrEditTriggerConditionForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.trigger_condition_num = 0.01;
    this.trigger_condition_type = "";
    this.trigger_condition_days = 0;
    this.trigger_condition_counts = 0;
    this.price_type = "price";
    this.price_type_list = ["price"];
    this.trigger_condition_shops = [];
    this.trigger_edit_guid = null;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "config_early_warning.form.trigger_condition_label_1_tip"
      ),
      trigger: "blur"
    }
  ])
], AddOrEditTriggerConditionForm.prototype, "trigger_condition_num", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "config_early_warning.form.trigger_condition_type_tip"
      ),
      trigger: "blur"
    }
  ])
], AddOrEditTriggerConditionForm.prototype, "trigger_condition_type", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "config_early_warning.form.trigger_condition_label_3_tip"
      ),
      trigger: "blur"
    }
  ])
], AddOrEditTriggerConditionForm.prototype, "trigger_condition_days", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "config_early_warning.form.trigger_condition_label_4_tip"
      ),
      trigger: "blur"
    }
  ])
], AddOrEditTriggerConditionForm.prototype, "trigger_condition_counts", 2);
let AddOrEditTriggerConditionDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.isCreate = true;
    this.dialogLoading = false;
    this.index = null;
    this.controller = new AddOrEditTriggerConditionForm();
    this.triggerType = "";
    this.trigger_condition_type_list = [
      {
        label: i18n.t("config_early_warning.form.trigger_condition_all_shops"),
        value: "ALL"
      },
      {
        label: i18n.t(
          "config_early_warning.form.trigger_condition_selected_shops"
        ),
        value: "SPECIFIED"
      }
    ];
  }
  open(conditionData, index, triggerType) {
    return __async(this, null, function* () {
      var _a;
      this.triggerType = triggerType;
      if (conditionData) {
        this.isCreate = false;
        this.index = index;
        this.controller.trigger_edit_guid = (_a = conditionData.guid) != null ? _a : null;
        this.controller.trigger_condition_type = conditionData.shopRange;
        this.controller.trigger_condition_shops = conditionData.shops;
        if (triggerType === "Amazon_Price_Too_Low") {
          this.controller.price_type = conditionData.triggerCondition.price_type;
          if (conditionData.triggerCondition.adjusted_below_total_fees === true) {
            this.controller.price_type_list.push("total_fees");
          }
          if (conditionData.triggerCondition.check_discount === true) {
            this.controller.price_type_list.push("price");
            this.controller.trigger_condition_num = conditionData.triggerCondition.discount;
          }
        }
        if (triggerType === "Amazon_Price_Too_Low" || triggerType === "Amazon_Percentage_Off_Too_High" || triggerType === "Amazon_Coupon_Too_High") {
          this.controller.trigger_condition_num = conditionData.triggerCondition.discount;
        }
        if (triggerType === "Amazon_Goods_Caption_Edit_Too_Frequently" || triggerType === "Amazon_Main_Image_Adjusted_Too_Frequently") {
          this.controller.trigger_condition_days = conditionData.triggerCondition.days;
          this.controller.trigger_condition_counts = conditionData.triggerCondition.counts;
        }
      } else {
        this.isCreate = true;
        this.controller.trigger_edit_guid = null;
        this.controller.trigger_condition_type = "ALL";
        this.controller.trigger_condition_shops = [];
        if (triggerType === "Amazon_Price_Too_Low" || triggerType === "Amazon_Percentage_Off_Too_High" || triggerType === "Amazon_Coupon_Too_High") {
          this.controller.trigger_condition_num = 20;
        }
        if (triggerType === "Amazon_Goods_Caption_Edit_Too_Frequently" || triggerType === "Amazon_Main_Image_Adjusted_Too_Frequently") {
          this.controller.trigger_condition_days = 1;
          this.controller.trigger_condition_counts = 1;
        }
      }
      this._uiDialog.show();
    });
  }
  closeDialog() {
    return __async(this, null, function* () {
      this._uiDialog.hide();
    });
  }
  submit() {
    return __async(this, null, function* () {
      let data = {
        isCreate: this.isCreate,
        index: this.index,
        guid: this.controller.trigger_edit_guid,
        shopRange: this.controller.trigger_condition_type,
        shops: this.controller.trigger_condition_shops
      };
      if (this.triggerType === "Amazon_Price_Too_Low" || this.triggerType === "Amazon_Percentage_Off_Too_High" || this.triggerType === "Amazon_Coupon_Too_High") {
        data.discount = this.controller.trigger_condition_num;
      }
      if (this.triggerType === "Amazon_Price_Too_Low") {
        data.price_type = this.controller.price_type;
        if (this.controller.price_type_list.includes("total_fees")) {
          data.adjusted_below_total_fees = true;
        } else {
          data.adjusted_below_total_fees = false;
        }
        if (this.controller.price_type_list.includes("price")) {
          data.check_discount = true;
          data.discount = this.controller.trigger_condition_num;
        } else {
          data.check_discount = false;
        }
      }
      if (this.triggerType === "Amazon_Goods_Caption_Edit_Too_Frequently" || this.triggerType === "Amazon_Main_Image_Adjusted_Too_Frequently") {
        data.days = this.controller.trigger_condition_days;
        data.counts = this.controller.trigger_condition_counts;
      }
      this.$emit("changeTriggerCondition", data);
      this._uiDialog.hide();
    });
  }
  changeEnvShops(data) {
    return __async(this, null, function* () {
      console.log(data);
      this.controller.trigger_condition_shops = data.selectedShops;
    });
  }
  changeTriggerConditionType() {
    if (this.controller.trigger_condition_type === "ALL") {
      this.controller.trigger_condition_shops = [];
    }
    if (this.controller.trigger_condition_type === "SPECIFIED") {
      this._addInprogressShopsDialog.open();
    }
  }
  openAddInprogressShopsDialog() {
    this._addInprogressShopsDialog.open(
      this.controller.trigger_condition_shops
    );
  }
};
__decorateClass([
  Ref("uiDialog")
], AddOrEditTriggerConditionDialog.prototype, "_uiDialog", 2);
__decorateClass([
  Ref("addInprogressShopsDialog")
], AddOrEditTriggerConditionDialog.prototype, "_addInprogressShopsDialog", 2);
AddOrEditTriggerConditionDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      AddInprogressShopsDialog
    }
  })
], AddOrEditTriggerConditionDialog);
export {
  AddOrEditTriggerConditionDialog as default
};
